<template>
	<div class="row">
		<audio id="audio-message" :src="urlsound"></audio>
		<div class="conversation" v-if="messages.length > 0">
			<div v-for="message in messages" class="col-12" :key="message.id">
				<div
					:class="
						message.to == 99999 || message.to == 'Suporte'
							? 'd-flex justify-content-end'
							: 'd-flex justify-content-start'
					"
				>
					<div
						:class="`card-message p-2 m-2 ${
							message.to == 99999 || message.to == 'Suporte'
								? 'user-destination received float-right'
								: 'user-auth sent right float-left'
						}`"
						:style="message.file_type ? 'max-width: 50%;' : ''"
					>
						<p class="m-0 mb-2">
							<span class="font-weight-bold float-left mr-3">
								{{
									message.to == 99999 || message.to == "Suporte"
										? "Você"
										: message.support_name
										? message.support_name
										: "Suporte"
								}}
							</span>
							<span v-if="message.created_at" class="font-weight-light float-right">
								{{ message.created_at | moment("DD/MM/YYYY HH:mm") }}
							</span>
							<span class="font-weight-light float-right" v-else>
								{{ new Date() | moment("DD/MM/YYYY HH:mm") }}
							</span>
						</p>
						<div class="row px-3" style="display: contents">
							<p v-html="message.text" :class="message.file_type ? '' : 'm-0 col-12'"></p>

							<a
								v-if="message.file_type == 'image'"
								:href="`${urlbase}${message.file}`"
								class="col"
								target="_blank"
								:title="message.file_name"
							>
								<!-- <p class="m-0 col-12 px-0">
                                    {{ message.file_name }}
                                </p> -->
								<img :src="`${urlbase}${message.file}`" class="img-fluid" />
							</a>
							<video
								width="100%"
								height="150px"
								controls
								v-if="
									message.file_type == 'video/mp4' ||
									message.file_type == 'mp4' ||
									message.file_type == 'mkv' ||
									message.file_type == 'audio' ||
									message.file_type == 'webm'
								"
							>
								<source :src="`${urlbase}${message.file}`" type="video/mp4" />
								<source :src="`${urlbase}${message.file}`" type="video/ogg" />
								Seu navegador não suporta a tag de vídeo.
							</video>
							<iframe
								v-if="
									message.file_type ==
										'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
									message.file_type ==
										'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
									message.file_type == 'application/pdf' ||
									message.file_type == 'pdf' ||
									message.file_type == 'docx' ||
									message.file_type == 'doc' ||
									message.file_type == 'ppt' ||
									message.file_type == 'pptx' ||
									message.file_type == 'txt' ||
									message.file_type == 'xls' ||
									message.file_type == 'xlsx' ||
									message.file_type == 'csv' ||
									message.file_type == 'sql' ||
									message.file_type == 'text/plain'
								"
								class="col"
								:src="`https://docs.google.com/gview?url=${urlbase}${message.file}&embedded=true`"
								style="width: 100%; height: 400px"
								frameborder="0"
								id="iframe"
							></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="messages.length <= 0" class="conversation col-12">
			<div class="text-center" style="margin-top: 20% !important">
				<span v-if="box == 'suporte'">
					<h3>Está com alguma dificuldade ou dúvida?</h3>
					<h3>Manda pra gente que te ajudamos 😉</h3>
				</span>
				<h3 v-else>
					Escolha
					{{ type == "contatos" ? "uma pessoa" : "um grupo" }} ao lado para iniciar uma
					conversa.
				</h3>
			</div>
		</div>
		<div
			class="col-12 load-text py-2 d-flex justify-content-center"
			style="position: absolute; bottom: 100px"
			v-if="loadmessage"
		>
			<hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
		</div>
		<div
			class="col-12 load-text row px-3"
			style="position: absolute; bottom: 0; z-index: 99"
			v-if="writemessage"
		>
			<hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
			{{ writesupportname }} está digitando
		</div>
		<div
			class="col-12 load-text row px-3"
			style="position: absolute; bottom: 0; z-index: 99"
			v-if="sending"
		>
			<hollow-dots-spinner :animation-duration="3000" :size="60" :color="'#fb8994'" />
			Enviando mensagem
		</div>
	</div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
	components: {
		HollowDotsSpinner,
	},
	props: {
		type: {
			type: String,
		},
		box: { type: String },
		writesupportname: { type: String, default: "" },
		messages: {
			type: Array,
			required: true,
		},
		sending: { type: Boolean },
		loadmessage: { type: Boolean },
		writemessage: { type: Boolean, default: false },
	},
	data() {
		return {
			urlbase: window.urlbase,
			urlsound: `${window.location.protocol}//${window.location.host}/sound/message-pop-up.mp3`,
		};
	},
	mounted() {
		this.scrollToBottom();
	},
	beforeMount() {
		this.scrollToBottom();
	},
	methods: {
		scrollToBottom() {
			setTimeout(() => {
				if (document.getElementById("msn-support")) {
					document.getElementById("msn-support").scroll({
						top: document.getElementById("msn-support").scrollHeight,
						left: 0,
					});
				}
			}, 50);
		},
		beep() {
			var audio = document.getElementById("audio-message");
			if (audio) {
				let startPlayPromise = audio.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
						})
						.catch((error) => {
							if (error.name === "NotAllowedError") {
								// showPlayButton(audio);
							} else {
								// Handle a load or playback error
							}
						});
				}
			}
		},
	},
	watch: {
		messages(messages) {
			this.scrollToBottom();
			setTimeout(() => {
				this.beep();
			}, 50);
		},
	},
};
</script>

<style lang="scss" scoped>
.card-message {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid #fdfdff !important;
	border-radius: 1rem;
}
::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}
.direct-chat-info {
	display: block;
	margin-top: 15px;
}
.user-destination {
	background: #bbdefb;
}
.user-auth {
	background: #b2dfdb;
}
.msn {
	overflow-y: scroll;

	ul {
		list-style-type: none;
		padding: 5px;

		li {
			&.message {
				margin: 10px 0;
				width: 100%;

				.text {
					max-width: 200px;
					border-radius: 5px;
					padding: 12px;
					display: inline-block;
				}

				&.received {
					text-align: right;

					.text {
						background: #b2b2b2;
					}
				}

				&.sent {
					text-align: left;

					.text {
						background: #81c4f9;
					}
				}
			}
		}
	}
}
.user-auth.sent:before {
	content: "";
	position: absolute;
	top: 0;
	left: -6px;
	width: 0;
	height: 0;
	border: 8px solid transparent;
	border-right-color: #b2dfdb;
	border-top-color: #b2dfdb;
}
.user-destination.received:before {
	content: "";
	position: absolute;
	top: 0;
	right: -6px;
	-moz-transform: scaleY(-1);
	-o-transform: scaleY(-1);
	-webkit-transform: scaleY(-1);
	transform: scaleY(-1);
	width: 0;
	height: 0;
	border: 8px solid transparent;
	border-left-color: #bbdefb;
	border-bottom-color: #bbdefb;
}

#msn-support {
	// height: 60vh;
	overflow-y: auto;
	overflow-x: hidden;
}

@media (min-width: 767px) AND (max-width: 1200px) {
	#msn-support {
		// height: 50vh;
		overflow-y: auto;
		overflow-x: hidden;
	}
}
</style>
